export const analyzeSiteReport = async (text) => {
  // شبیه‌سازی زمان پردازش هوش مصنوعی (1.5 ثانیه)
  await new Promise(resolve => setTimeout(resolve, 1500));

  const result = {
    summary: '',
    metrics: [],
    risks: [],
    recommendations: []
  };

  const lowerText = text.toLowerCase();

  // ۱. تشخیص نوع عملیات و خلاصه
  if (lowerText.includes('خاکریزی') || lowerText.includes('بیس') || lowerText.includes('ساب‌گرید')) {
    result.summary = 'عملیات خاکی / روسازی جاده';
  } else if (lowerText.includes('بتن') || lowerText.includes('آرماتور') || lowerText.includes('قالب')) {
    result.summary = 'عملیات بتن‌ریزی / اجرای سازه';
  } else {
    result.summary = 'گزارش عمومی کارگاه';
  }

  // ۲. استخراج پارامترهای کنترلی (مثلاً تراکم)
  const compactionMatch = text.match(/تراکم.*?(\d{2,3})(?:\s*%|\s*درصد)/);
  if (compactionMatch) {
    const value = parseInt(compactionMatch[1]);
    result.metrics.push({
      label: 'تراکم ثبت‌شده',
      value: `${value}%`,
      status: value >= 95 ? 'success' : 'warning'
    });
    if (value < 95) result.risks.push(`تراکم گزارش شده (${value}%) کمتر از حد مجاز (95%) است.`);
  }

  const volumeMatch = text.match(/حجم.*?(\d+(?:\.\d+)?)\s*(?:متر\s*مکعب|m3|تن)/);
  if (volumeMatch) {
    result.metrics.push({
      label: 'حجم عملیات',
      value: `${volumeMatch[1]} واحد`,
      status: 'info'
    });
  }

  // ۳. تشخیص ریسک‌ها و مشکلات رایج کارگاهی
  if (lowerText.includes('آب') && (lowerText.includes('کمبود') || lowerText.includes('قطعی'))) {
    result.risks.push('گزارش کمبود آب در کارگاه (تأثیر روی تراکم و عمل‌آوری).');
  }
  if (lowerText.includes('خراب') || lowerText.includes('توقف')) {
    result.risks.push('توقف یا خرابی ماشین‌آلات در گزارش ذکر شده است.');
  }
  
  // بررسی الزامات استاندارد (مثلاً اگر بتن‌ریزی یا خاکریزی داریم، باید اسم آزمایشگاه باشد)
  if ((result.summary.includes('خاکی') || result.summary.includes('بتن')) && !lowerText.includes('آزمایشگاه') && !lowerText.includes('شیت')) {
    result.risks.push('شماره شیت یا حضور ناظر آزمایشگاه در متن رؤیت نشد.');
    result.recommendations.push('پیگیری نتایج آزمایش (شیت دانسیته/مقاومت) از پیمانکار.');
  }

  // ۴. پیشنهادات عمومی
  if (result.risks.length > 0) {
    result.recommendations.push('بررسی موارد ریسک در جلسه کارگاهی فردا.');
  } else {
    result.recommendations.push('روند اجرای کار مطابق استاندارد به نظر می‌رسد. بایگانی گزارش.');
  }

  return result;
};
